export default class ZaikoDistributor
{
    constructor (name)
    {
        this.Hanbaisaki = name;
        // Shukka
        this.Orders = 0;
        this.Sales = 0;
        this.Profit = 0;
    }
}